export default __webpack_public_path__ + "static/img/anderson-medical.02bc6ba.jpg";